import '../../../assets/login.css';

import useForm from './useForm';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const PasswordRecovery = () => {
  const { submitHandler, formInputs, setFormInputs, errors, loading } = useForm();
  const { t, i18n } = useTranslation();

  return (
    <div className="col-lg-12 col-sm-12 login-banner">
      <div className="row d-flex justify-content-center ">
        <div className="col-lg-5  col-10  registration-card">
          <div className="container">
            <div className="row">
              <div className="col-12 text-center">
                <h2 className="login-card-title ">{t('password-recovery.title')}</h2>
              </div>

              <div className="col-12">
                <form>
                  <div className="col-12 form-group login-form-input">
                    <label htmlFor="email" className="font-weight-bold">
                      {t('password-recovery.label.email')}{' '}
                    </label>
                    <input
                      type="text"
                      className={` form-control  pt-3 pb-3 ${errors ? 'is-invalid' : ''} ${errors == '' ? 'is-valid' : ''}`}
                      id="email"
                      aria-describedby="Email"
                      placeholder={t('password-recovery.placeholder.email')}
                      value={formInputs.email}
                      onChange={(e) => {
                        setFormInputs({ ...formInputs, email: e.target.value });
                      }}
                    />
                    <div className="valid-feedback">{t('password-recovery.label.email-sent')}</div>
                    <div className="invalid-feedback">{errors}</div>
                  </div>

                  <button
                    type="submit"
                    className="btn btn-warning  btn-block btn-lg font-weight-bold d-flex justify-content-center "
                    disabled={loading}
                    onClick={submitHandler}
                    style={{ fontSize: '20px' }}
                  >
                    <span
                      className="spinner-border "
                      role="status"
                      aria-hidden="true"
                      style={{ display: loading === true ? 'block' : 'none' }}
                    ></span>
                    <span className=""> {t('password-recovery.label.send')} </span>
                  </button>
                  <div className="row mr-2 ml-2 mt-2 d-flex justify-content-between">
                    <div className="text-center  ">
                      <Link to="/login">{t('password-recovery.label.connect')} </Link>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PasswordRecovery;
